import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Button from 'src/components/ui/Button/Button';
import useCustomPrompt from 'src/utils/useCustomPrompt';

import classes from './PageHeader.module.scss';

export interface PageHeaderProps {
  className?: string;
  showBackButton?: boolean;
  backConfirmationText?: string;
  title: string;
  endNode?: ReactNode;
  onBackClick?: () => void;
}

const PageHeader: FC<PageHeaderProps> = ({
  className,
  showBackButton = false,
  backConfirmationText,
  title,
  endNode,
  onBackClick,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useCustomPrompt(backConfirmationText, !!backConfirmationText);

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div
      className={classNames(classes.Container, className, {
        [classes.HasBackButton]: showBackButton,
      })}
    >
      {showBackButton && (
        <Button
          className={classes.BackButton}
          startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
          onClick={onBackClick ?? handleBackClick}
        >
          {t('common:back')}
        </Button>
      )}
      <header>
        <h2>{title}</h2>
        {endNode}
      </header>
    </div>
  );
};

export default PageHeader;
